/* tslint:disable */
/* eslint-disable */
/**
 * Spring API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClearPendingTasksResponse
 */
export interface ClearPendingTasksResponse {
    /**
     * 
     * @type {string}
     * @memberof ClearPendingTasksResponse
     */
    message: string;
    /**
     * 
     * @type {number}
     * @memberof ClearPendingTasksResponse
     */
    deletedCount: number;
}

/**
 * Check if a given object implements the ClearPendingTasksResponse interface.
 */
export function instanceOfClearPendingTasksResponse(value: object): value is ClearPendingTasksResponse {
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('deletedCount' in value) || value['deletedCount'] === undefined) return false;
    return true;
}

export function ClearPendingTasksResponseFromJSON(json: any): ClearPendingTasksResponse {
    return ClearPendingTasksResponseFromJSONTyped(json, false);
}

export function ClearPendingTasksResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClearPendingTasksResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'deletedCount': json['deleted_count'],
    };
}

export function ClearPendingTasksResponseToJSON(json: any): ClearPendingTasksResponse {
    return ClearPendingTasksResponseToJSONTyped(json, false);
}

export function ClearPendingTasksResponseToJSONTyped(value?: ClearPendingTasksResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'deleted_count': value['deletedCount'],
    };
}

